import React from 'react';
import { T } from '../../helpers/i18n';
import theme from '../../Theme';
import { toMoney } from '../../helpers/Format';
import { PaymentMethod } from '../../Models/TicketPayment';
import moment from 'moment';
import cxs from 'cxs/component';
export var RenderPayments = function (_a) {
    var item = _a.item;
    // console.log('renderPayments - payments: ', item.payments)
    if (item.payments && item.payments.length > 0) {
        /*if (item.payments.length === 1) {
          return (<p style={{ textDecoration: item.daterefund?'line-through': 'initial', margin: '0', padding: 0, textAlign: 'end', }}>
            {`${t(item.payments[0].method)}: ${item.payments[0].method === PaymentMethod.Credit? item.payments[0].afiliateName? item.payments[0].afiliateName: '' : ''}`}
          </p>)
        }*/
        var dataText_1 = function (payment) { return ("".concat(T(payment.method), ": ").concat(toMoney(payment.amount, item.money), " ").concat(payment.method === PaymentMethod.Credit ? payment.afiliateName ? payment.afiliateName : '' : '')); };
        return React.createElement("div", { style: { display: 'inline-block', border: "1px solid ".concat(theme.color.secondary), padding: '1rem' } }, item.payments.filter(function (pago) { return pago.method !== PaymentMethod.Due; }).map(function (payment) {
            var logDate;
            if (payment.log) {
                logDate = moment(payment.log.date).format('DD/MM/YYYY HH:mm:ss');
            }
            return (React.createElement("div", { key: payment.method, style: {
                    textDecoration: item.daterefund || (payment.method === PaymentMethod.Due && !item.totalDue) ? 'line-through' : 'inherit',
                    backgroundColor: payment.method === PaymentMethod.Due && item.totalDue > 0 ? 'red' : 'inherit',
                    color: payment.method === PaymentMethod.Due && item.totalDue > 0 ? 'white' : 'inherit',
                } },
                payment.log && React.createElement("div", null,
                    React.createElement(Wrapper, null, "".concat(dataText_1(payment))),
                    React.createElement(Wrapper, null, "".concat(T('transaction'), ": ").concat(payment.log.transaction_id)),
                    React.createElement(Wrapper, null, "".concat(T('date'), ": ").concat(logDate, " "))),
                !payment.log && React.createElement("div", null, dataText_1(payment))));
        }));
    }
    else {
        return (React.createElement("p", { style: { textDecoration: item.daterefund ? 'line-through' : 'initial', margin: '0', padding: 0, textAlign: 'end', } }, "".concat(T(item.tipoPago ? item.tipoPago : PaymentMethod.Cash))));
    }
};
var Wrapper = cxs('div')({
    color: 'green',
});



//////////////////
// WEBPACK FOOTER
// ./src/components/Ticket/Payments.tsx
// module id = 1157
// module chunks = 0